
/**
 * UpdateInspecaoPatrimonioUseCase
 */

import dayjs from "dayjs";
import { IUpdateInspecaoPatrimonioUseCase } from "../../../presentation/useCases/update/update_inspecao_patrimonio_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class UpdateInspecaoPatrimonioUseCase implements IUpdateInspecaoPatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updateInspecaoPatrimonio(
    idInspecaoPatrimonio: number,
    idPatrimonioChecklistMaquinaEquip: number | null,
    idFuncionarioAprovado: number | null,
    idFuncionarioInspecionado: number | null,
    dataInspecao: Date | null,
    dataEncerramento: Date | null,
    descricao: string | null,
    observacao: string | null,
    status: number | null,
    inspecaoPatrimonioItens?: {
      idInspecaoPatrimonioItens: number;
      descricao: string | null;
      inspecao1: string | null;
      dataInspecao1: Date | null;
      inspecao2: string | null;
      dataInspecao2: Date | null;
    }[],
    fillCurrentDate?: boolean,
  ): Promise<void> {
    await this.repository.updateInspecaoPatrimonio(
      idInspecaoPatrimonio,
      idPatrimonioChecklistMaquinaEquip,
      idFuncionarioAprovado,
      idFuncionarioInspecionado,
      dataInspecao,
      dataEncerramento,
      descricao,
      observacao,
      status,
      (inspecaoPatrimonioItens ?? []).map(x => {
        if (x.dataInspecao1 === null) {
          if (fillCurrentDate) {
            return ({ ...x, dataInspecao1: dayjs(new Date()).startOf('day').utc().toDate() });
          }
        }
        return x;
      }),
    );
  }
}
